<template>
    <div>
        <base-form-control v-bind="formControlAttributes" @clear-clicked="clear" class="input-bg">
            <slot name="prepend"></slot>
            <label class="form-file">
                <span v-if="text === ''" class="text-white">Attach Resume/Cv</span>
                <input ref="fileInput" v-on="listeners" @change="updateValue" :disabled="disabled"
                       type="file" accept="application/pdf"/>
            </label>
            <slot name="append"></slot>
        </base-form-control>
        <span v-text="text" class="fs--2"></span>
        <p class="text-danger fs--2" v-if="fileInvalid">File should be pdf.</p>
    </div>
</template>

<script>
import BaseFormControl from './BaseFormControl';
import BaseInput from './BaseInput';

export default {
    name: 'custom-file-input',
    components: { BaseFormControl },
    extends: BaseInput,
    data () {
        return {
            text: '',
            fileInvalid: false
        };
    },
    methods: {
        updateValue (evt) {
            const target = evt.target;
            const files = Array.from(target.files);
            this.files = files;
            const len = files.length;
            if (len === 0) {
                return;
            }

            if (len === 1) {
                const file = files[0];
                this.text = file.name;
            } else if (len > 1) {
                this.text = `${len} files selected`;
            }

            this.$emit('input', this.files);

            const type = this.text.split('.')[1];
            if (type !== 'pdf') {
                this.fileInvalid = true;
                this.$refs.fileInput.value = '';
                this.files = '';
                this.text = '';
            } else {
                this.fileInvalid = false;
            }
        }
    }

};
</script>
<style scoped lang="scss">
.input-bg {
    background-color: #222D65;
    color: white !important;
    border-radius: 6px;
}
</style>
